<template>
  <div class="countDown">剩余时间 {{restInHuman}}</div>
</template>

<script>
import moment from 'moment';

function padZero(i) {
  return `${i}`.length >= 2 ? i : `0${i}`;
}

export default {
  name: 'countDown',
  data() {
    return {
      rest: 0
    };
  },

  computed: {
    restInHuman() {
      let rest = this.rest;
      let h = Math.ceil(rest / (60 * 60)) - 1;
      rest = rest % (60 * 60);
      let m = Math.ceil(rest / 60);
      rest = rest % 60;
      let s = rest;
      return `${padZero(h)}:${padZero(m)}:${padZero(s)}`;
    }
  },

  created() {
    this.timer = null;
  },

  mounted() {
    let mNow = moment();
    let mEndOfDay = mNow
      .clone()
      .add(1, 'day')
      .hour(0)
      .minute(0)
      .second(0)
      .millisecond(0);
    this.rest = Math.ceil(mEndOfDay.diff(mNow) / 1000);
    this.timer = setInterval(() => {
      this.rest--;
      if (this.rest <= 0) {
        clearInterval(this.timer);
      }
    }, 1000);
  },

  destroyed() {
    clearInterval(this.timer);
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/index.scss';
.countDown {
  color: #fbd97c;
  @include set-property(font-size, 22);
}
</style>


